import { useEffect } from 'react';

import ClaimPromoGiftDialog from '../components/Dialogs/PromoDialogs/ClaimPromoGiftDialogV2/ClaimPromoGiftDialog';
import DailyLimitDialog from '../components/Dialogs/PromoDialogs/DailyLimitDialog/DailyLimitDialog';
import InvalidPromoDialog from '../components/Dialogs/PromoDialogs/InvalidPromoDialogV2/InvalidPromoDialog';
import { useStores } from '../stores/useStores';

export function useSetPromoPopup() {
  const { portalStore, promotionStore, featureManagerStore } = useStores();

  useEffect(() => {
    if (promotionStore.isPromoListenersEmpty) {
      promotionStore.addPromoListener((promotion) =>
        portalStore.openPortal(ClaimPromoGiftDialog, {
          promotion,
          persistent: true,
          beforeClose: () => {
            promotionStore.markPromotionFlowFinished();
            featureManagerStore.onDialogFinished('PromoGift');
          },
        }),
      );
    }

    if (promotionStore.isPromoErrorListenersEmpty) {
      promotionStore.addPromoErrorListener((errorCode) => {
        const DialogComponent = errorCode === 'PromoCodeDailyLimitError' ? DailyLimitDialog : InvalidPromoDialog;

        portalStore.openPortal(DialogComponent, {
          errorCode,
          persistent: true,
          beforeClose: () => {
            promotionStore.markPromotionFlowFinished();
            featureManagerStore.onDialogFinished('PromoGift');
          },
        });
      });
    }
  }, [portalStore, promotionStore, featureManagerStore]);
}
